import React from "react";
import { Rate as Rating } from "antd";
import { colors } from "../../share/constants/enums";

const Rate = ({ value, disabled }) => {
  return (
    <>
      <Rating
        style={{
          color: colors.secondaryOrange,
        }}
        value={value}
        disabled={disabled}
        allowHalf
        defaultValue={3}
      />
    </>
  );
};

export default Rate;
